<script setup>
import { computed, ref } from 'vue'
import IconBase from '../icon/IconBase.vue';
import Tooltip from '../Atoms/Tooltip.vue';
import IconStars from '../icon/IconStars.vue';

const props = defineProps({
  expanded: {
    type: Boolean,
  },
  title: {
    type: String,
  },
  icon: {
    type: Object,
  },
  width: {
    type: [Number, String],
    default: 16
  },
  height: {
    type: [Number, String],
    default: 16
  },
  widthViewBox: {
    type: [Number, String],
    default: 16
  },
  heightViewBox: {
    type: [Number, String],
    default: 16
  },
  withAnimation: {
    type: Boolean,
    default: false
  },
})


</script>

<template>
  <span v-show="props.expanded">
    <icon-base class="shrink-0" fill="none" :width="props.width" :height="props.height"
      :widthViewBox="props.widthViewBox" :heightViewBox="props.heightViewBox">
      <component :is="props.icon" />
    </icon-base>
    <icon-base v-if="props.withAnimation" class="shrink-0 absolute !top-2 !left-6 overflow-visible z-10" fill="none" :width="16" :height="16"
      :widthViewBox="512" :heightViewBox="512">
      <IconStars />
    </icon-base>
  </span>
  <span v-show="!props.expanded">
    <Tooltip :content="props.title">
      <icon-base class="shrink-0 mx-auto" fill="none" :width="props.width" :height="props.height"
        :widthViewBox="props.widthViewBox" :heightViewBox="props.heightViewBox">
        <component :is="props.icon" />
      </icon-base>
      <icon-base v-if="props.withAnimation" class="shrink-0 absolute !top-2 !left-6 overflow-visible z-10" fill="none" :width="16"
        :height="16" :widthViewBox="512" :heightViewBox="512">
        <IconStars />
      </icon-base>
    </Tooltip>
  </span>

</template>

<style scoped></style>
